export default __webpack_public_path__ + "static/icon-size-up-16794cb95201a90a6a70b1657b39e582.webp";